<template>
    <div>
        <div class="TTL-dialog">
        <el-dialog v-model="param.view" title="查看出生信息" width="30%" :before-close="closeBefore">
            <el-form :model="form" align="center" v-loading="param.loading">
                <el-form-item label="出生日期" label-width="80">
                <el-date-picker
                    v-model="param.birthday"
                    type="date"
                    size="large"
                    placeholder="出生日期"
                    value-format="YYYY-MM-DD"
                />
                </el-form-item>
                <el-form-item label="备注信息" label-width="80">
                <el-input type="textarea" v-model="param.content" placeholder="备注" rows="3" round size="large"/>
                </el-form-item>
                <el-form-item>
                <el-row class="TTL-prennatal-thumb">
                    <div class="TTL-PRENATAL-thumb thumb-default" @click="uploadthumbs(index)"></div>
                    <div class="TTL-PRENATAL-thumb" v-for="(thumb,index) in param.thumblist">
                    <div class='TTL-PRENATAL-CLOSE'><el-button type="danger" size="small" circle icon="Close" @click="delthumbs(index)" /></div>
                    <el-image 
                    :src="thumb" 
                    :preview-src-list="[thumb]" 
                    :initial-index="1"
                    preview-teleported="true"
                    :zoom-rate="1.2" 
                    fit="cover"  
                    />
                    </div>
                </el-row>
                </el-form-item>
            </el-form>
            <div class="TTL-footer">
                <el-button type="warning" size="large" round @click="saveBirthday">保存</el-button>
                <el-button size="large" round @click="closeBefore">取消</el-button>
            </div>

        </el-dialog>
        </div>

         <!-- 自定义组件 -->
        <!-- 图片上传组件 -->
        <div><input type="file" id="birthdayinfos" style="display:none;" multiple @change="getMyfiles" /></div>

    </div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
export default {
    props: ['value','memberid'],
    data() {
        return {
            
            param: {
                view:false,
                id:'',
                memberid:'',
                birthday:'',
                content:'',
                thumblist:'',
                loading:false,
            },

            /** 上传图片参数 **/
            thumbparam: {
                type:'library',
                imagetype:'library',
            },

        }
    },

    watch: {
        value(val) {
            if(val) {
                this.param.view=true;
                this.param.memberid=this.memberid;
                this.resetparam(); //重置参数
                this.getbirthdayinfos(); //获取成员出生信息
            }
        },
    },

    mounted() {
        
    },

    methods: {

        /** 删除上传图片 **/
        delthumbs(index) {
            this.param.thumblist.splice(index,1);
        },


        /** 保存出生信息 **/
        saveBirthday() {
            this.param.thumbs=JSON.stringify(this.param.thumblist);
            INTERFACE_MODEL_GENEALOGY.SAVE_MEMBER_BIRTHDAY(this.param).then((res) => {
                if(res.status > 0) return false;
                this.closeBefore();
            });
        },


        /** 获取家庭成员出生信息 **/
        getbirthdayinfos() {
            INTERFACE_MODEL_GENEALOGY.GET_MEMBER_BIRTHDAY_INFOS({id:this.param.memberid}).then((res) => {
                if(res.status > 0) return false;
                let data=res.data;
                this.param.id=data.id > 0 ? data.id : 0;
                this.param.birthday=data.birthday ? data.birthday : '';
                this.param.content=data.content ? data.content : '';
                this.param.thumblist=data.thumb ? data.thumb : [];
            });
        },


        /** 重置参数 **/
        resetparam() {
            this.param.birthday='';
            this.param.content='';
            this.param.thumblist=[];
        },

        /** 关闭操作窗口 **/
        closeBefore() {
            this.param.view=false;
            this.$emit('birthdayfinish');
        },


        /** 上传就诊图片 **/
        uploadthumbs(index) {
            this.thumbparam.index=index;
            document.getElementById('birthdayinfos').click();
        },


        /** 获取问诊图片 **/
        getMyfiles(e) {
            let _this=this;            
            for(var i=0; i < e.srcElement.files.length; i++) {
                //上传图片到接口操作
                INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:_this.thumbparam.imagetype,File:e.srcElement.files[i]}).then((res) => {
                    if(res.status > 0) return false;
                    let url=this.$ImageAddress+res.data.url;
                    _this.param.thumblist.push(url);
                });
            }

            e.srcElement.value=''; //清空数据
        },


    },

}
</script>
<style scoped>
.TTL-dialog {text-align:left !important;}
.TTL-setting-image-detail {width:80px;height:80px;text-align:center;margin:0 auto;}
.TTL-setting-image-detail .el-image {width:80px;height:80px;border-radius:50%;}

.TTL-prennatal-thumb {border-top:1px dashed #E6E8EB;width:100%;display:flex;justify-content:left;padding:20px 0;margin-top:20px;}
.TTL-PRENATAL-thumb {width:120px;height:120px;border-radius:6px;border:1px solid #E4E7ED;margin:0 15px 15px 0;Position:relative;}
.TTL-PRENATAL-thumb .el-image {overflow:hidden;width:120px;height:120px;border-radius:6px;}
.thumb-default {cursor:pointer;display:inline-block;background:url(@/assets/icon/plus-add.png) no-repeat;background-size:25px;background-Position:center;}
.TTL-PRENATAL-CLOSE {width:20px;height:20px;border-radius:50%;Position:absolute;right:0;top:0;margin-right:-10px;margin-top:-10px;z-index:10;display:flex;justify-content:center;align-items:center;}
.TTL-prennatal-info-detail-main {width:calc(100% - 20px);border-radius:6px;border:1px solid #CDD0D6;padding:10px;margin-bottom:10px;}
:deep(.TTL-prennatal-info-detail-main .el-textarea__inner) {box-shadow: none !important;}
.TTL-prenatal-close {width:25px;height:25px;cursor:pointer;Position:absolute;right:0;top:0;border-radius:0 0 0 25px;background:#F56C6C url(@/assets/icon/close.png) no-repeat;background-size:8px;background-Position:11px 8px;}
</style>